import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import paths from "routes/paths";

import css from "./type.module.scss";

export const TrialAvailable = () => {
  return (
    <div className={clsx(css.wrapper, css.green)}>
      <div className={css.content}>
        <Link className={css.link} to={paths.purchase()}>
          <strong>Start your 3 days trial today.</strong>
        </Link>
      </div>
    </div>
  );
};
